import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
import { GET_API_URLS } from "../../../../utils/constant";
import jwtInterceoptor from "../../../../api/jwtInterceptor";
import { Loader, PropanePopupCard } from "../../../../components/ui";
import styles from "./styles.module.scss";

const PropanePopup = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [propanePopupList, setPropanePopupList] = useState(null);
  // const navigate = useNavigate();

  useEffect(() => {
    // Getting Propane Popup List
    jwtInterceoptor
      .get(GET_API_URLS.PROPANE_POPUP)
      .then((response) => {
        setLoading(false);
        setPropanePopupList(response.data);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 403) {
          setError("You don't have permission to access this page.");
        } else {
          setError("There was a problem while loading the data.");
        }
        console.log("Error", error);
      });
  }, []);

  return (
    <div className={styles.propanePopupPage}>
      {error ? (
        <h3 style={{ textAlign: "center" }}>{error}</h3>
      ) : (
        <>

          {loading ? (
            <div className={styles.loadingPage}>
              <Loader />
            </div>
          ) : propanePopupList ? (
            <div className={styles.popupBlock}>
              {propanePopupList?.length > 0 ? (
                propanePopupList.map((popup, i) => (
                  <PropanePopupCard
                    key={i}
                    id={popup.id}
                    image={popup.image}
                    link={popup.link}
                    title={popup.title}
                    caption={popup.caption}
                    active={popup.active}
                    data={{ ...popup }}
                  />
                ))
              ) : (
                <div className={styles.noDataMessage}>
                  <h2>No Propane Popups Found</h2>
                  <p>Click "Add New Popup" to create your first propane popup.</p>
                </div>
              )}
            </div>
          ) : null}
        </>
      )}
    </div>
  );
};

export default PropanePopup;
